import { Outlet } from "react-router"
import { AccessContainer } from "./styles"

export const AccessLayout = () => {
  return (
    <AccessContainer>
      <Outlet />
    </AccessContainer>
  )
}